import { useState } from 'react';
import clsx from 'clsx';
import { Text } from 'components/Elements';
import { Box, DollarSign, Home, RefreshCcw } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Sidebar = () => {
  const [showLabels, setShowLabels] = useState(true);

  return (
    <div className="fixed h-full w-[20%] p-4 ml-10">
      {/* Main Navigation Section */}
      <div className={clsx('mb-6 bg-white shadow-lg rounded-3xl', 'p-6')}>
        <nav>
          <ul className="list-none space-y-3">
            <Link to="/app" className="flex flex-row items-center space-x-2">
              <div className="bg-white shadow p-2 rounded-lg">
                <Home size={20} />
              </div>
              <Text>Overview</Text>
            </Link>
            <Link
              to="/app/currencies"
              className="flex flex-row items-center space-x-2"
            >
              <div className="bg-white shadow p-2 rounded-lg">
                <DollarSign size={20} />
              </div>
              <Text>Currencies</Text>
            </Link>
            <Link
              to="/app/swap-rates"
              className="flex flex-row items-center space-x-2"
            >
              <div className="bg-white shadow p-2 rounded-lg">
                <RefreshCcw size={20} />
              </div>
              <Text>Swap rates</Text>
            </Link>
            <Link
              to="/app/payment-methods"
              className="flex flex-row items-center space-x-2"
            >
              <div className="bg-white shadow p-2 rounded-lg">
                <Box size={20} />
              </div>
              <Text>Payment methods</Text>
            </Link>
          </ul>
        </nav>
      </div>

      {/* Quick Actions Section */}
      <div className={clsx('mb-3 bg-white shadow-lg rounded-3xl', 'p-6')}>
        <nav>
          <ul className="list-none space-y-3">
            <li>
              <Text variant="lead" className="font-semibold">
                Quick actions
              </Text>
            </li>
            <li>Setup currency</li>
            <li>Create swap</li>
            <li>Add fee</li>
            <li>Set limit</li>
            <li>Add provider</li>
          </ul>
        </nav>
      </div>
      <div className={clsx('bg-white shadow-lg rounded-3xl', 'p-6')}>
        <nav>
          <ul className="list-none space-y-3">
            <li>Widgets</li>
          </ul>
        </nav>
      </div>
    </div>
  );
};
